import { COUNTRIES } from './constants'

export const getCountryName = (country) => COUNTRIES[country] || null

export const shouldRenderDisplayName = (displayName, countryName) =>
  displayName && !!countryName
